import { render, staticRenderFns } from "./brands-list.vue?vue&type=template&id=5a0d6a64&"
import script from "./brands-list.js?vue&type=script&lang=js&"
export * from "./brands-list.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports